import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { pluginRegistry } from '../config';

export default function PluginsPage() {
  return (
    <Layout>
      <div className="page">
        <h1>Plugins</h1>
        {pluginRegistry.length === 0 && (
          <p className="muted">No plugins are registered.</p>
        )}
        <ul className="plugin-list">
          {pluginRegistry.map(plugin => (
            <li key={plugin.id}>
              {plugin.kind === 'browser' ? (
                <Link to={`/plugins/${plugin.id}`}>{plugin.title}</Link>
              ) : (
                <span>{plugin.title}</span>
              )}
              <span className="muted small">
                {plugin.kind === 'api' ? plugin.base_url : plugin.id}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
}
